import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Logo } from '@/components/sidebar';
import { Button, Card, Input, Label } from '@/components/ui';
import { api, ApiError, queryClient } from '@/lib/api';

export function LoginPage() {
  const [password, setPassword] = useState('');
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const login = useMutation({
    mutationFn: () => api.login(password),
    onSuccess: async () => {
      queryClient.clear();
      navigate(params.get('next') || '/', { replace: true });
    },
    onError: () => undefined,
    onSettled: () => undefined,
  });
  return (
    <div className="flex min-h-full items-center justify-center bg-[radial-gradient(ellipse_at_top,var(--color-accent),transparent_60%)] p-4">
      <div className="w-full max-w-sm animate-rise">
        <div className="mb-6 flex flex-col items-center gap-3 text-center">
          <Logo size={48} />
          <div>
            <h1 className="text-2xl font-semibold">GoalBuddy</h1>
            <p className="text-sm text-muted-fg">Your goals, with a buddy who keeps you moving.</p>
          </div>
        </div>
        <Card className="p-6">
          <form
            className="space-y-4"
            onSubmit={(e) => {
              e.preventDefault();
              login.mutate();
            }}
          >
            <div className="space-y-1.5">
              <Label htmlFor="pw">Password</Label>
              <Input
                id="pw"
                type="password"
                autoFocus
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {login.error && (
              <div className="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">
                {login.error instanceof ApiError ? login.error.message : 'Login failed'}
              </div>
            )}
            <Button type="submit" className="w-full" disabled={!password || login.isPending}>
              {login.isPending ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
